import { format,parse,differenceInSeconds } from 'date-fns';

export class DriveScheduleTrip {
    id:any = 0;
    idRow:any = 0;
    idxRow:number = -1;
    idSchedule:any = 0;
    idxSchedule:number = -1;
    dtgUnitId:string = "";
    dtgRegDt:string = "";
    dtgRegDtYy:number = 0;
    dtgRegDtMm:number = 0;
    dtgRegDtDd:number = 0;
    dtgRegDtHh:number = 0;
    dtgRegDtFrom:string = "";
    dtgRegDtTo:string = "";
    dtgCarNo:string = "";
    dtgCarType:string = "";
    dtgCarTypeNm:string = "";
    userId:string = "";
    userNm:string = "";
    companyId:string = "";
    companyNm:string = "";
    fvmsTripCnt:string = "";
    dtFromTrip:string = "";
    dtToTrip:string = "";
    dtFromRest:string = "";
    dtToRest:string = "";
    err:any = {};
    msg:any = {};
    durSecTrip:number = 0;
    durMinuteTrip:number = 0;
    import(resItem){
        for(let key1 in resItem){
            if(this.hasOwnProperty(key1) === true){
                this[key1] = resItem[key1];
            }
        }
        this.dtFromTrip = this.dtgRegDtFrom;// 운행 시작일시
        this.dtToTrip = this.dtgRegDtTo;// 운행 종료일시
        this.dtFromRest = this.dtgRegDtTo;// 휴식 시작일시 (운행종료일시)
        this.dtToRest = this.dtgRegDtTo;// 휴식 종료일시 (운행종료일시) -> 다음 운행 시작일시로 업데이트
    };
    setDtToTrip(dtTo:string){
        if(dtTo){
            this.dtToTrip = dtTo;
            this.dtFromRest = this.dtToTrip;
        }
    }
    setDtFromRest(dtFrom:string){
        if(dtFrom){
            this.dtFromRest = dtFrom;
            this.dtToTrip = this.dtFromRest;
        }
    }
    getDtFromTripDate(){
        return parse(this.dtFromTrip,"yyyy-MM-dd HH:mm:ss",new Date());//운행시작
    };
    getDtToTripDate(){
        return parse(this.dtToTrip,"yyyy-MM-dd HH:mm:ss",new Date());//운행종료
    };
    getDtFromTripTxt(){
        return this.dtFromTrip;
    };
    getDtToTripTxt(){
        return this.dtToTrip;
    }
    getDtFromRestDate(){
        return parse(this.dtFromRest,"yyyy-MM-dd HH:mm:ss",new Date());//휴식시작
    };
    getDtToRestDate(){
        return parse(this.dtToRest,"yyyy-MM-dd HH:mm:ss",new Date());//휴식종료
    };
    getDtFromRestTxt(){
        return this.dtFromRest;
    };
    getDtToRestTxt(){
        return this.dtToRest;
    }
    getDurSecTrip(){
        return differenceInSeconds(this.getDtToTripDate(),this.getDtFromTripDate());
    };
    getDurMinuteTrip(){
        return Math.floor(this.getDurSecTrip() / 60);
    }
    getDurSecRest(){
        return differenceInSeconds(this.getDtToRestDate(),this.getDtFromRestDate());
    };
    getDurMinuteRest(){
        return Math.floor(this.getDurSecRest() / 60);
    };
    checkValid(){
        let promise = new Promise<void>((resolve) => {
            switch(this.dtgCarType){
                case "11"://시내버스
                case "12"://농어촌버스
                case "13":{//마을버스
                    //1.시내,농어촌 및 마을버스
                    //  - 각 회차 종료 후 10분 이상 휴식 보장
                    //  - 회차 운행시간 2시간 이상일 경우 15분 이상 휴식 보장
                    //  - 회차 운행시간 4시간 이상일 경우 30분 이상 휴식 보장
                    if(this.getDurMinuteRest() < 10){
                        // 휴식시간이 15분 보다 작은 경우
                        this.err["dur.Trip.rest.min"] = this.getDurMinuteRest();
                        let msg = `<div class="text-nowrap">각 회차 종료 후 10분 이상 휴식 보장 필요</div>`;
                        this.msg["dur.Trip.rest.min"] = msg;
                    }else if(this.getDurMinuteRest() < 15 && this.getDurMinuteTrip() >= 60 * 2 && this.getDurMinuteTrip() < 60 * 4){
                        // 휴식시간이 15분 보다 작고 운행시간이 2시간 이상 4시간 미만
                        this.err["dur.Trip.rest.min"] = this.getDurMinuteRest();
                        let msg = `<div class="text-nowrap">운행시간 2시간 이상일 경우 15분 이상 휴식 보장 필요</div>`;
                        this.msg["dur.Trip.rest.min"] = msg;
                    }else if(this.getDurMinuteRest() < 30 && this.getDurMinuteTrip() >= 60 * 4){
                        // 휴식시간이 30분 보다 작고 운행시간이 4시간 이상
                        this.err["dur.Trip.rest.min"] = this.getDurMinuteRest();
                        let msg = `<div class="text-nowrap">운행시간 4시간 이상일 경우 30분 이상 휴식 보장 필요</div>`;
                        this.msg["dur.Trip.rest.min"] = msg;
                    }
                }break;
                case "14"://시외버스
                case "15"://고속버스
                case "16":{//전세버스
                    //2.시외(고속)버스 / 전세버스
                    //  - 각 회차 종료 후 15분 이상 휴식 보장
                    //  - 회차 운행시간 3시간 이상일 경우 30분 이상 휴식 보장
                    if(this.getDurMinuteRest() < 15){
                        // 휴식시간이 15분 보다 작은 경우
                        this.err["dur.Trip.rest.min"] = this.getDurMinuteRest();
                        let msg = `<div class="text-nowrap">각 회차 종료 후 15분 이상 휴식 보장 필요</div>`;
                        this.msg["dur.Trip.rest.min"] = msg;
                    }else if(this.getDurMinuteRest() < 30 && this.getDurMinuteTrip() >= 60 * 3){
                        // 휴식시간이 30분 보다 작고 운행시간이 3시간 이상인 경우
                        this.err["dur.Trip.rest.min"] = this.getDurMinuteRest();
                        let msg = `<div class="text-nowrap">운행시간 3시간 이상일 경우 30분 이상 휴식 보장 필요</div>`;
                        this.msg["dur.Trip.rest.min"] = msg;
                    }
                }break;
                default:{
                    // ,{dtgCarType:"17",dtgCarTypeNm:"특수여객"}
                    // ,{dtgCarType:"21",dtgCarTypeNm:"일반택시"}
                    // ,{dtgCarType:"22",dtgCarTypeNm:"개인택시"}
                    // ,{dtgCarType:"31",dtgCarTypeNm:"일반화물"}
                    // ,{dtgCarType:"32",dtgCarTypeNm:"개별화물"}
                    // ,{dtgCarType:"41",dtgCarTypeNm:"비사업용"}
                    if(this.getDurMinuteRest() < 15){
                        // 휴식시간이 15분 보다 작은 경우
                        this.err["dur.Trip.rest.min"] = this.getDurMinuteRest();
                        let msg = `<div class="text-nowrap">각 회차 종료 후 15분 이상 휴식 보장 필요</div>`;
                        this.msg["dur.Trip.rest.min"] = msg;
                    }else if(this.getDurMinuteRest() < 30 && this.getDurMinuteTrip() >= 60 * 3){
                        // 휴식시간이 30분 보다 작고 운행시간이 3시간 이상인 경우
                        this.err["dur.Trip.rest.min"] = this.getDurMinuteRest();
                        let msg = `<div class="text-nowrap">운행시간 3시간 이상일 경우 30분 이상 휴식 보장 필요</div>`;
                        this.msg["dur.Trip.rest.min"] = msg;
                    }
                }break;
            }
            resolve();
        });
        return promise;
    }
}